<div class="p-20">

  @for (sensor of sensors; track sensor._id) {
    <app-card [showHeader]="false" padding="10" [style.opacity]="sensor?.config?.enable ? 1: 0.5">
      <div>
        <mat-slide-toggle
          color="success"
          [checked]="sensor.config?.enable"
          (change)="toggleEnable(sensor)"
        >
          <label>{{ sensor.label?.['es'] || sensor.label?.['default'] }}</label>
        </mat-slide-toggle>

        &nbsp; &nbsp;

        @if (sensor.config?.editable && sensor.config.enable) {
          <mat-slide-toggle
            [disabled]="!sensor.config?.editable"
            [checked]="sensor?.config?.edit"

            (change)="sensor.config.edit = !sensor.config.edit"

            color="success"
          >
            <label>Personalizar</label>
          </mat-slide-toggle>
        }
      </div>

      @if (sensor.config?.edit && sensor.config.enable) {

        <app-field-expression
          [label]="'Configuracion'"
          [inputOptionsUrl]="inputOptionsUrl"
          [value]="sensor.config?.expression"
          (valueChange)="sensor.config.expression = $event"

          mode="simple"
          hideMode="true"
        />

      }

    </app-card>
  }

  <div class="col-12 col-md-12">
    <div class="grid">
      <button
        mat-flat-button color="primary"
        class="mat-body f-w-500"
        [disabled]="isSubmitting"
        (click)="onSubmit()"
      >
        @if (isSubmitting) {
          {{ 'Guardando ...' }}
        } @else {
          {{ 'Guardar' }}
        }
      </button>
    </div>
  </div>

</div>
